import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard Analytics
import DashboardAnalyticsReducer from "./dashboardAnalytics/reducer";

//Pages
import ProductsReducer from "./products/reducer";
import OrdersReducer from "./orders/reducer";
import NotificationsReducer from "./notifications/reducer";
import BillingReducer from "./billing/reducer";
import UsersReducer from "./users/reducer";

// API Key
import APIKeyReducer from "./apiKey/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  DashboardAnalytics: DashboardAnalyticsReducer,
  APIKey: APIKeyReducer,
  Products: ProductsReducer,
  Orders: OrdersReducer,
  Notifications: NotificationsReducer,
  Billing: BillingReducer,
  Users: UsersReducer,
});

export default rootReducer;
